import React from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import ConfirmButton from '../../../../components/confirm-button';

function ActionRenderer(props) {
  const {
    data, handleDelete, deletingMembers, updatingMembers,
  } = props;
  if (!data) {
    return null;
  }
  const id = data._id;
  const deleting = deletingMembers[id] === true;
  const updating = updatingMembers[id] === true;
  const disabled = deleting || updating;
  return (
    <ConfirmButton
      size="xs"
      confirmStyle="danger"
      onConfirm={() => { handleDelete(data); }}
      disabled={disabled}
    >
      <span>
        {!deleting && <span><Fa name="times" /> Remove</span>}
        {deleting && <span><Fa name="spinner" spin /> Removing</span>}
      </span>
    </ConfirmButton>
  );
}
ActionRenderer.propTypes = {
  handleDelete: PropTypes.func,
  data: PropTypes.shape({}),
  deletingMembers: PropTypes.shape({}),
  updatingMembers: PropTypes.shape({}),
};
ActionRenderer.defaultProps = {
  handleDelete: () => {},
  data: null,
  deletingMembers: {},
  updatingMembers: {},
};

export default ActionRenderer;

